/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import React from "react";
import { TableCell, TableRow, IconButton, Checkbox, Chip } from "@material-ui/core";
import DeleteOutlined from "@material-ui/icons/DeleteOutlined";
import EditOutlined from "@material-ui/icons/EditOutlined";
import CheckIcon from "@material-ui/icons/Check";

/**
 * Displays a single contact row with select, edit and delete actions
 * @param {Object} props
 * @param {Object} props.contact contact record to display
 * @param {Boolean} props.isSelected flag to mark the row selected
 * @param {(contactId: string) => void} props.toggleSelectContactId function to toggle row selection
 * @param {() => void} props.deleteContact function to delete the contact
 * @param {(contactId: string) => any} props.editContact function to edit the contact
 */
export const ExternalContactsTableRow = ({
	contact,
	isSelected,
	toggleSelectContactId,
	deleteContact,
	editContact,
}) => {
	return (
		<TableRow key={contact.contactId}>
			<TableCell>
				<Checkbox
					className="px-0"
					color="secondary"
					checked={isSelected}
					onChange={() => toggleSelectContactId(contact.contactId)}
				/>
			</TableCell>
			<TableCell>{contact.fullName}</TableCell>
			<TableCell>{contact.phone}</TableCell>
			<TableCell>
				{contact?.tags?.map((tag, i) => (
					<Chip key={tag + i} variant="outlined" size="small" label={tag} style={{ margin: "2px 5px 2px 0" }} />
				))}
			</TableCell>
			<TableCell>{contact.azureAdUserId}</TableCell>
			<TableCell>{contact.teamsInfo && contact.teamsInfo.conversationId && <CheckIcon />}</TableCell>
			<TableCell align="right">
				<IconButton title="Edit contact" size="small" onClick={() => editContact(contact.contactId)}>
					<EditOutlined />
				</IconButton>
				<IconButton title="Delete contact" size="small" color="secondary" onClick={deleteContact}>
					<DeleteOutlined />
				</IconButton>
			</TableCell>
		</TableRow>
	);
};
